import React, { useState, useContext } from "react"
import Layout from "./../../layout"
import SEO from "./../../seo"

// s4n
import { injectIntl } from "gatsby-plugin-intl"
import kebabCase from "lodash.kebabcase"
import ContextProductIndex from './../../../s4n/context/ProductIndex'
import ProductIndexTemplate from "./../templates/product-index"


import loadable from '@loadable/component'
import Preloader from './../Preloader'
import Categories from './Sidebar/categories'
import FilterFormSidebar from './../../forms/Filter/product-index-sidebar'
import FilterFormTop from './../../forms/Filter/product-index-top'
// import FilterTest from './../../forms/Filter/test'
// import Pagination from './../Pagination'
import PaginationStatic from './../Pagination/static'
import PaginationDynamic from './../Pagination/dynamic'
// import { DisplayFormikState } from "./../../forms/formikHelper"
import UseDrupalBlockContentBasic from './../../../hooks/drupal/blockContentBasic'



const translation = {
    results: {
        pl: `Wyniki`,
        en: `Results`,
        de: `Ergebnisse`,
        es: `Resultados`,
    },
    no_results: {
        pl: `Brak wyników`,
        en: `No results`,
        de: `Keine Ergebnisse`,
        es: `No hay resultados`,
    }
}

const ComponentFunctional = (props) => {
    const { intl, propsData } = props;
    const t = intl.formatMessage;

    const { pageContext, aDataCollectionTranslated } = propsData;
    const contextProductIndex = useContext(ContextProductIndex);

    // const [state, setState] = useState({
    //     loading: false,
    //     error: false,
    //     queryResult: null,
    // });

    const [stateCurrentPage, setStateCurrentPage] = useState({
        // pageCount: contextProductIndex.paginator.pageCount,
        currentPage: contextProductIndex.filters.offset / contextProductIndex.filters.limit || 0,
    });

    // This should correspond with shop page CMS link!!!
    const linkMap = {
        pl: `Sklep`,
        en: `Shop`,
    }
  
    // @todo: refactor
    const categoryTitle = pageContext.category ? pageContext.category : linkMap[intl.locale];
    const linkTranslation = kebabCase(linkMap[intl.locale]);
    
    const state = contextProductIndex.data;
    
    let resultsCount = pageContext.countCategories[pageContext.category ? pageContext.category : `undefined`];
    // console.log(contextProductIndex.paginator.pageCount)
    // let pageCount = null;

    // Transform response structure to match Gatsyb GraphQL obtained from JSON:API
    if (
        // !state.loading && 
        state.queryResult
    ) {
        // propsData.aDataCollectionTranslated = contextProductIndex.data.queryResult.data.commerceProductQuery.entities;
        // propsData.aDataCollectionTranslated = contextProductIndex.transformStructure(state.queryResult.data.commerceProductQuery.entities);
        propsData.aDataCollectionTranslated = state.queryResult.data.commerceProductQuery.entities;

        // setState({
        //     pageCount: contextProductIndex.paginator.pageCount,
        // });

        resultsCount = state.queryResult.data.commerceProductQuery.count;
        // pageCount = contextProductIndex.paginator.pageCount;
        // pageCount = Math.ceil(resultsCount / contextProductIndex.filters.limit);
    }

    // @todo: refactor!!!
    const onPageChange = async (data) => {
        const filters = {...contextProductIndex.filters};
        const currentPage = data.selected;

        setStateCurrentPage({
            // pageCount: contextProductIndex.paginator.pageCount,
            currentPage: currentPage,
        });
        // setStateCurrentPage((prevState, props) => ({
        //     ...prevState,
        //     currentPage: currentPage,
        // }));

        const offset = Math.ceil(currentPage * filters.limit);

        // actions.setStatus(undefined);
        contextProductIndex.updateFilters({
            offset: offset,
        });

        // contextProductIndex.updatePaginator({
        //     currentPage: currentPage,
        // });

        // console.log(currentPage)
        // console.log(filters.limit)
        // console.log(offset)
        // console.log(contextProductIndex.paginator)
    }

    // console.log(pageContext)
    // console.log(index.edges)

    // Does this work with Context?
    // const FilterFormSidebar = loadable(() => import(`./../../forms/Filter/product-index-sidebar`), {fallback: <Preloader />});
    // const FilterFormTop = loadable(() => import(`./../../forms/Filter/product-index-top`), {fallback: <Preloader />});
    // const FilterTest = loadable(() => import(`./../../forms/Filter/test`), {fallback: <Preloader />});

    /**
     * Reset context filters values
     * 
     * @param {*} values 
     * @param {*} actions 
     */
    const onReset = (values, actions) => {
        contextProductIndex.updateFilters(contextProductIndex.getFiltersInitial());
    }

    const blockShopContentTop = <UseDrupalBlockContentBasic blockId={70} />

    return (
        <Layout 
        // node={data.node}
        >
            {/* <DisplayFormikState {...state} /> */}

            <SEO 
                title={categoryTitle} 
                _keywords={``} 
            />

            <div id="shop" className="container">
                <div className="row no-gutters">
                    <div className="col">
                        <h1>{categoryTitle}</h1>
                    </div>
                </div>

                {blockShopContentTop && 
                    <div className="row">
                        <div className="col">
                            {blockShopContentTop}
                        </div>
                    </div>
                }

                <div className="row pt-3">
                    <div className="col-lg-3">
                        <div className="_wp-block-soft4net-container-block _container-fluid sidebar _bg-blue">
                            <div className="row">
                                <div className="_col-md-6 col-lg-12 mb-5">
                                    <div className="filters">
                                        {/* <Categories pageContext={pageContext} linkTranslation={linkTranslation} /> */}
                                        <UseDrupalBlockContentBasic blockId={69} />
                                        <FilterFormSidebar onReset={onReset} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">

                        {/* <React.Fragment>
                            <DisplayFormikState {...contextProductIndex.filters} />
                        </React.Fragment> */}
                        {/* {state.queryResult ? 
                            <React.Fragment>
                                <DisplayFormikState {...contextProductIndex.filters} />
                                <DisplayFormikState {...contextProductIndex.paginator} />
                            </React.Fragment>
                            :
                            null
                        } */}

                        <FilterFormTop onReset={onReset} />
                        {/* <FilterTest /> */}

                        {state.loading ? 
                            <Preloader />
                            : 
                            <React.Fragment>
                                {resultsCount > 0 ? 
                                    <React.Fragment>
                                        <p className="pt-3">{translation.results[intl.locale]}: {resultsCount}</p>
                                        <ProductIndexTemplate data={propsData} />
                                        {state.queryResult ? 
                                            <PaginationDynamic onPageChange={onPageChange} currentPage={stateCurrentPage.currentPage} />
                                            :
                                            <PaginationStatic pageContext={pageContext} linkTranslation={linkTranslation} />
                                        }
                                    </React.Fragment>
                                    :
                                    <p className="pt-3">{translation.no_results[intl.locale]}</p>
                                }
                            </React.Fragment>
                        }
                    </div>
                </div>
            </div>

        </Layout>
    )
}

export default injectIntl(ComponentFunctional)